import React, { useMemo } from "react";

const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

export default function ProjectKpis({ kpis, loading, tasks = [] }) {
  const derived = useMemo(() => {
    const total     = tasks.length;
    const done      = tasks.filter(t => t.status === "Done").length;
    const inProg    = tasks.filter(t => t.status === "In Progress").length;
    const overdue   = tasks.filter(t => t.due_date && new Date(t.due_date) < new Date() && t.status !== "Done").length;
    const p1        = tasks.filter(t => t.priority === "Critical").length;
    const completion= total ? Math.round((done / total) * 100) : 0;
    return { total, done, inProg, overdue, p1, completion };
  }, [tasks]);

  const stats = kpis || derived;

  const CHIPS = [
    { label: "Total Tasks",    value: stats.total,               color: "#00ff90"  },
    { label: "In Progress",    value: stats.inProg ?? stats.in_progress, color: "#60a5fa"  },
    { label: "Completed",      value: stats.done ?? stats.completed,     color: "#34d399"  },
    { label: "Completion %",   value: `${stats.completion ?? 0}%`,       color: "#fbbf24"  },
    { label: "Overdue",        value: stats.overdue,             color: "#f87171"  },
    { label: "Critical",       value: stats.p1 ?? stats.critical,color: "#f43f5e"  },
  ];

  return (
    <div className={`${card} p-5`}>
      <div className="grid grid-cols-2 md:grid-cols-6 gap-3">
        {CHIPS.map(({ label, value, color }) => (
          <div key={label} className="rounded-lg border border-white/5 bg-white/3 p-3 text-center">
            {loading ? <div className="h-6 rounded bg-white/10 animate-pulse mb-1" /> : (
              <p className="text-lg font-bold" style={{ color }}>{value ?? "—"}</p>
            )}
            <p className="text-xs text-white/30 mt-0.5">{label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}